// eslint-disable-next-line no-unused-vars
import React from 'react';
import ReactGA from 'react-ga';
import { isAnalyticsEnabled } from '../helpers/analytics';

// Events are dropped for stores with seo off (see helpers/analytics)
const useGAEventTracker = (category = 'Category') => {
  return (action = 'action', label = 'label') => {
    if (!isAnalyticsEnabled()) return;
    ReactGA.event({
      category,
      action,
      label,
    });
  };
};

export default useGAEventTracker;
